import { Flex } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { OnboardingHeading } from '../_components/OnboardingHeading';

/** Logo tile, title and description of a connection (mock-up step 4). */
export const ConnectHeader = ({
  logo,
  title,
  description,
}: {
  logo: ReactNode;
  title: string;
  description: string;
}) => (
  <>
    <Flex
      w="48px"
      h="48px"
      mb="18px"
      borderRadius="12px"
      bg="white"
      borderWidth="1px"
      borderColor="cardBorder"
      align="center"
      justify="center"
    >
      {logo}
    </Flex>
    <OnboardingHeading title={title} subtitle={description} />
  </>
);
